import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import StdDialog from 'components/Dialogs/NewStdDialog';
import SearchBox from 'components/SearchBox';
import ZeroStateView from 'components/ZeroStateView';
import zeroStateIcon from 'assets/zero-state-images/safebox.svg';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Divider from '@material-ui/core/Divider';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Avatar from '@material-ui/core/Avatar';
import DialogContent from '@material-ui/core/DialogContent';
import { makeStyles } from '@material-ui/core/styles';

import { getUserVerifiedScheduledTransactions } from 'data/scheduledTransactions/scheduledTransactionsSelectors';
import { frequencyAliasFromRecurrence } from 'data/scheduledTransactions/scheduledTransactionsUtils';
import { getAccountString } from 'data/accounts/retrievers';
import AmountField from 'components/QuickenControls/AmountField';

const useStyles = makeStyles((theme) => ({
  searchBar: {
    backgroundColor: theme.palette.greyScale[6],
    margin: 8,
  },
  zeroStateView: {
    margin: 20,
  },
}));

const SelectScheduledTransactionDialog = (props) => {
  const classes = useStyles(props);
  const scheduledTransactions = useSelector(getUserVerifiedScheduledTransactions);
  const [search, setSearch] = useState();

  const filteredScheduledTransactions = scheduledTransactions
    .filter((scheduledTransaction) => {
      let include = true;
      if (search) {
        include = scheduledTransaction.transaction.payee.toLowerCase().includes(search);
        if (!include) {
          const frequencyAlias = frequencyAliasFromRecurrence(scheduledTransaction.recurrence);
          include = frequencyAlias.toLowerCase().includes(search);
        }
        if (!include) {
          include = String(scheduledTransaction.transaction.amount).includes(search);
        }
        if (!include) {
          const accountString = getAccountString(scheduledTransaction.transaction.accountId);
          include = accountString.toLowerCase().includes(search);
        }
      }
      return include;
    })
    .toList()
    .sort((scheduledTransaction1, scheduledTransaction2) => scheduledTransaction1.transaction.payee.localeCompare(scheduledTransaction2.transaction.payee, undefined, {
      sensitivity: 'base',
      numeric: true,
      caseFirst: 'upper',
    }));

  return (
    <StdDialog
      title="Assign to Existing&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
      {...props}
    >
      <DialogContent>
        <SearchBox
          onSearch={(key) => setSearch(key && key.toLowerCase())}
          autoSearch
          collapsable={false}
          placeholder="Search Scheduled Transactions"
          className={classes.searchBar}
        />
        {!filteredScheduledTransactions.size ?
          <ZeroStateView
            primary="We couldn't find any scheduled transactions"
            icon={zeroStateIcon}
            secondary="Try resetting the search"
            useSmallerFont
            className={classes.zeroStateView}
          />
          :
          <List
            component="nav"
            aria-label="setup recurring options"
            style={{padding: 0}}
          >
            {filteredScheduledTransactions.map((scheduledTransaction, index) => (
              <React.Fragment key={scheduledTransaction.id}>
                <ListItem
                  id={`existing-recurring-transaction-${index}`}
                  button
                  onClick={() => {
                    if (props.onSelected) {
                      props.onSelected(scheduledTransaction);
                    }
                  }}
                >
                  <ListItemIcon>
                    <Avatar>{scheduledTransaction.transaction.payee[0].toUpperCase()}</Avatar>
                  </ListItemIcon>

                  <ListItemText
                    primary={scheduledTransaction.transaction.payee}
                    secondary={frequencyAliasFromRecurrence(scheduledTransaction.recurrence)}
                  />

                  <ListItemText
                    primary={
                      <AmountField
                        optimisticSign
                        color={scheduledTransaction.transaction.amount > 0 ? 'green' : undefined}
                        value={scheduledTransaction.transaction.amount}
                      />
                    }
                    secondary={getAccountString(scheduledTransaction.transaction.accountId)}
                    secondaryTypographyProps={{ style: { textAlign: 'right', marginLeft: 20 } }}
                  />

                  <ListItemSecondaryAction>
                    <NavigateNextIcon/>
                  </ListItemSecondaryAction>
                </ListItem>

                {filteredScheduledTransactions.size > 1 ? <Divider/> : undefined}
              </React.Fragment>
            ))}
          </List>
        }
      </DialogContent>
    </StdDialog>
  );
};

SelectScheduledTransactionDialog.propTypes = {
  onSelected: PropTypes.func,
};

export default SelectScheduledTransactionDialog;
